<template>
  <div class="survey-cake-page" :class="{ 'pdf-mode': isPDF }">
    <img src="@/assets/survey-cake/end-page.jpg" class="end-page" />
  </div>
</template>

<script>
export default {
  name: "EndPage",
  props: {
    isPDF: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.survey-cake-page {
  width: 100vw;
  height: calc((3508 / 2480) * 100vw);
  background-color: #fae4cb;
  position: relative;
  .end-page {
    width: 100%;
    vertical-align: middle;
  }
}
.survey-cake-page.pdf-mode {
  width: 2480px;
  height: 3508px;
}
</style>
